import * as pages from './page-names';

export const homeRoute = '/' + pages.homePageName;

export const changePasswordRoute = '/' + pages.changePasswordPageName;
export const forgotPasswordRoute = '/' + pages.forgotPasswordPageName;
export const editProfileRoute = '/' + pages.editProfilePageName;
export const loginRoute = '/' + pages.loginPageName;
export const userManagementRoute = '/' + pages.userManagementPageName;
export const userEditRoute = '/' + pages.userEditPageName;
export const clientAdministrationRoute = '/' + pages.clientAdministrationPageName;
export const categoryRoute = '/' + pages.categoryPageName;
export const subscriptionRoute = '/' + pages.subscriptionPageName;
export const privacypolicyRoute = '/' + pages.privacypolicyPageName;
export const publicPrivacyPolicyRoute = '/' + pages.publicPrivacyPolicyPageName;
export const orderRoute = '/' + pages.orderPageName;
export const DeliveryDetailsRoute = '/' + pages.deliverydetailsPageName;
export const productTemplateRoute = '/' + pages.productTemplatePageName;
export const salesOverviewRoute = '/' + pages.salesOverviewPageName;
export const invoiceRoute = '/' + pages.invoicePageName;




